// extracted by mini-css-extract-plugin
export default {"button":"primary-button_button__EmCe+","primary":"primary-button_primary__d3bux","gray":"primary-button_gray__gpFPj","white":"primary-button_white__536et"};